import { Component, OnInit, ChangeDetectionStrategy, Input, inject } from '@angular/core';
import { Breadcrumb } from '../../models/breadcrumb.model';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
    selector: 'app-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BreadcrumbsComponent {
  @Input() breadcrumbs: Breadcrumb[] = [];
  @Input() showHome: boolean = true;

  location = inject(Location);
  constructor(private router: Router, private activatedRoute: ActivatedRoute) {}

  get crumbs() {
    if (this.showHome) {
      return [
        {
          label: 'Home',
          routerLink: ['/'],
        },
        ...this.breadcrumbs,
      ];
    }
    return this.breadcrumbs;
  }
  get backCrumb() {
    if (this.crumbs.length > 1) {
      return this.crumbs[this.crumbs.length - 2];
    }
    return {
      label: 'Home',
      routerLink: ['/'],
    };
  }

  goBack(): void {
    const navigationId = (this.location.getState() as any)?.navigationId || 0;
    if (navigationId > 1) {
      this.location.back();
    } else {
      this.router.navigate(this.backCrumb.routerLink, { queryParams: this.backCrumb.params });
    }
  }
}
